import React, { useState, useRef, useMemo, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import Menu from 'components/Menu';
import { FormTitle, VcEGrid, VcGrid } from 'components/Grid';
import WarehouseModal from 'components/Modal/WareHouseModal';
import Input from 'components/Material/Input';
import Select from 'components/Material/Select';

import DateOneSePickersTyping from 'components/DatePicker/DateOneSePickersTyping';
import DateTimeOneSePickersTyping from 'components/DatePicker/DateTimeOneSePickersTyping';

import { isType, localeTw, userTypeList } from 'main_consts';
import { Iobject, Ioption } from 'main_type';
import {
  getfindImctUserId,
  getfindSealNoInfo,
  postSearch,
  snackBarRsp,
  confirm,
  deleteItem,
  exportPicture,
} from 'main_api';

import { AgGridReact } from 'ag-grid-react';
import { GridOptions } from 'ag-grid-community';

import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';
import Alert from '@material-ui/lab/Alert';
import PrintIcon from '@material-ui/icons/Print';
import EditIcon from '@material-ui/icons/Edit';
import SaveIcon from '@material-ui/icons/Save';
import RefreshIcon from '@material-ui/icons/Refresh';
import DeleteIcon from '@material-ui/icons/Delete';
import { Autocomplete } from '@material-ui/lab';
import { TextField } from '@material-ui/core';

import { useSnackbar } from 'notistack';
import { setLoadingRedux } from 'reducers/shareData/action';
import {
  getUserInfoRedux,
  getWareHouseListRedux,
} from 'reducers/shareData/selector';
import Header from 'components/Header';
import {
  formatDate,
  formatDateTime,
  getDateDayPlus,
  getFindDropDownList,
  getfindDropDownContainerNoList,
  getfindImctUserIdlist,
  getfindSealNoInfolist,
  initWhrehhouse,
  inputChange,
  selectChange,
} from '../../../main_func';

import { Iresult, Imaster } from './type';

/** 貨櫃動態維護作業 */
const CtgdsStatusMtn = (): JSX.Element => {
  const warehouseRedux = useSelector(getWareHouseListRedux);
  const { user, userType, locationCode } = useSelector(getUserInfoRedux);
  const dispatch = useDispatch();
  const { enqueueSnackbar } = useSnackbar();
  const [formError, setFormError] = useState(false);
  const [submitKey, setSubmitKey] = useState('search');
  const apiName = 'ctgdsStatusMtn';
  const [rowData, setRowData] = useState<Iresult[]>([]);
  const [openSearchTable, setOpenSearchTable] = useState(false);
  const [randomValue, setRandomValue] = useState(Math.random());
  const [expressName, setExpressName] = useState('');
  const [warehouseName, setWarehouseName] = useState('');
  const [statusCodeOptions, setStatusCodeOptions] = useState<Ioption[]>([]);
  const [containerNoList, setContainerNoList] = useState<string[]>([]);
  const [images, setImages] = useState<Iresult[]>([]);
  const [defImctUserId, setDefImctUserId] = useState<string>('');

  const masterDefaultValue: Imaster = {
    // 拆櫃日期
    declDate: getDateDayPlus(),
    // 船掛
    vesselRegNo: '',
    // 貨櫃號碼
    containerNo: '',
    // 封條號碼
    sealNoInfo: '',
    // 動態日期
    statusDate: getDateDayPlus(),
    // 動態時間
    statusTime: '0000',
    // 貨櫃動態
    statusCode: '',
    imctUserId: defImctUserId,
    warehouse:
      userType === userTypeList.type1[0] || userType === userTypeList.type2[0]
        ? initWhrehhouse(userType, warehouseRedux, locationCode)
        : 'TPEE011S',
    statusDateValid: true,
    declDateValid: true,
    warehouseValid: true,

    chkCode1: '',

    pageSize: 100,
  };
  const [master, setMaster] = useState(masterDefaultValue);
  const getImctUserId = (warehouse: string) => {
    getfindImctUserIdlist(warehouse).then((item) => {
      setDefImctUserId(item);
      return item as string;
    });
    return '';
  };
  useEffect(() => {
    if (
      userType &&
      !(
        isType(userTypeList.admin, userType) ||
        isType(userTypeList.type1, userType)
      )
    ) {
      setFormError(true);
      enqueueSnackbar(`您無權限使用此功能!`);
    }
    setMaster((prev) => ({ ...prev, warehouse: masterDefaultValue.warehouse }));
    if (
      masterDefaultValue.warehouse &&
      masterDefaultValue.warehouse.length > 0
    ) {
      getFindDropDownList('findDropDownStatusCode', {
        warehouse: locationCode,
      }).then((item) => {
        setStatusCodeOptions(item);
      });
      getImctUserId(masterDefaultValue.warehouse);
    }
  }, [userType]);

  useEffect(() => {
    const list: Ioption[] = [];

    if (
      master.containerNo &&
      master.containerNo.length > 0 &&
      master.vesselRegNo &&
      master.vesselRegNo.length > 0
    ) {
      getfindSealNoInfolist(
        master.declDate,
        master.warehouse,
        master.containerNo,
        master.vesselRegNo
      ).then((SealNoInfo) => {
        setMaster((prev) => ({
          ...prev,
          sealNoInfo: SealNoInfo,
        }));
      });
    }
  }, [master.containerNo]);
  useEffect(() => {
    // console.log('master.vesselRegNo', master.vesselRegNo);
    // if (master.vesselRegNo && master.vesselRegNo.length > 0) {
    //   getfindDropDownContainerNoList(
    //     master.declDate,
    //     master.warehouse,
    //     master.vesselRegNo
    //   ).then((item) => {
    //     setContainerNoList(item);
    //   });
    // }
  }, [master.vesselRegNo]);
  useEffect(() => {
    const list: Ioption[] = [];

    if (master.warehouse && master.warehouse.length > 0) {
      getFindDropDownList('findDropDownStatusCode', {
        warehouse: locationCode,
      }).then((item) => {
        setStatusCodeOptions(item);
      });
      getfindDropDownContainerNoList(
        master.declDate,
        master.warehouse,
        master.vesselRegNo
      ).then((item) => {
        setContainerNoList(item);
      });
      getfindImctUserIdlist(master.warehouse).then((item) => {
        const resultData = item;
        setMaster((prev) => ({ ...prev, imctUserId: resultData }));
      });
    }
  }, [master.warehouse]);
  useEffect(() => {
    if (master.warehouse && master.warehouse.length > 0) {
      getfindDropDownContainerNoList(
        master.declDate,
        master.warehouse,
        master.vesselRegNo
      ).then((item) => {
        setContainerNoList(item);
      });
    }
  }, [master.declDate]);

  const handleReset = async () => {
    setMaster(masterDefaultValue);
    setImages([]);
    console.log('masterDefaultValue', masterDefaultValue);
    setMaster((prev) => ({ ...prev, imctUserId: defImctUserId }));
    // setExpressName('');
    // setWarehouseName('');
    // setOpenSearchTable(false);
    // setFormError(false);
    setRandomValue(Math.random());
  };

  const handleConfirm = async (
    e?: React.FormEvent<HTMLFormElement>
  ): Promise<void> => {
    if (e && e.preventDefault) {
      e.preventDefault();
    }
    dispatch(setLoadingRedux(true));

    const result = await confirm(apiName, {
      declDate: formatDate(master.declDate, 'yyyyMMdd'),
      warehouse: master.warehouse,
      vesselRegNo: master.vesselRegNo,
      containerNo: master.containerNo,
      sealNoInfo: master.sealNoInfo,
      statusDate: formatDateTime(master.statusDate, `${master.statusTime}00`),
      statusCode: master.statusCode,
      imctUserId: master.imctUserId,
    });

    dispatch(setLoadingRedux(false));
    if (!snackBarRsp(enqueueSnackbar, result)) {
      return;
    }
    setRandomValue(Math.random());
  };

  const handleDeleteItem = async (
    e?: React.FormEvent<HTMLFormElement>
  ): Promise<void> => {
    if (e && e.preventDefault) {
      e.preventDefault();
    }

    if (window.confirm('確定要刪除動態嗎？')) {
      dispatch(setLoadingRedux(true));
      const result = await deleteItem(apiName, {
        declDate: formatDate(master.declDate, 'yyyyMMdd'),
        warehouse: master.warehouse,
        vesselRegNo: master.vesselRegNo,
        containerNo: master.containerNo,
        sealNoInfo: master.sealNoInfo,
        statusDate: formatDateTime(master.statusDate, `${master.statusTime}`),
        statusCode: master.statusCode,
        imctUserId: master.imctUserId,
      });
      dispatch(setLoadingRedux(false));
      if (!snackBarRsp(enqueueSnackbar, result)) {
        return;
      }
    }
    setRandomValue(Math.random());
  };

  const handleGetPic = async (
    e?: React.FormEvent<HTMLFormElement>
  ): Promise<void> => {
    if (e && e.preventDefault) {
      e.preventDefault();
    }
    dispatch(setLoadingRedux(true));

    const result = await exportPicture(apiName, {
      declDate: formatDate(master.declDate, 'yyyyMMdd'),
      warehouse: master.warehouse,
      vesselRegNo: master.vesselRegNo,
      containerNo: master.containerNo,
      statusDate: formatDateTime(master.statusDate, `${master.statusTime}00`),
      statusCode: master.statusCode,
      imctUserId: master.imctUserId,
    });

    const picList = result.data.data as Iresult[];
    setImages(picList);
    dispatch(setLoadingRedux(false));
    if (!snackBarRsp(enqueueSnackbar, result)) {
      return;
    }
    setRandomValue(Math.random());
  };

  const handleSubmit = (e?: React.FormEvent<HTMLFormElement>) => {
    if (e && e.preventDefault) {
      e.preventDefault();
    }
    if (master.declDate.length === 0) {
      master.declDate = getDateDayPlus();
    }

    if (!master.statusDateValid || !master.warehouseValid) {
      return;
    }
    switch (submitKey) {
      case 'confirm':
        handleConfirm();
        break;
      case 'deleteItem':
        handleDeleteItem();
        break;
      case 'getPic':
        handleGetPic();
        break;
      default:
        break;
    }
  };

  const updateData = async (updateObj: Iobject) => {
    setMaster({ ...master, ...updateObj });
    const key: string[] = Object.keys(updateObj);
  };

  function getContainerNo(
    e: React.FocusEvent<HTMLInputElement | HTMLTextAreaElement>
  ) {
    if (e && e.preventDefault) {
      e.preventDefault();
    }
    // console.log('e.target.value', e.target.value);
    setMaster({ ...master, vesselRegNo: e.target.value });
    if (e.target.value && e.target.value.length > 0) {
      getfindDropDownContainerNoList(
        master.declDate,
        master.warehouse,
        e.target.value
      ).then((item) => {
        setContainerNoList(item);
      });
    }
  }

  return (
    <div id="page-area">
      <Header />
      <form onSubmit={handleSubmit} className="form-area">
        <div>
          <div className="title">
            <EditIcon /> 貨櫃動態維護作業
          </div>
        </div>
        <div className="input-area">
          {userType && isType(userTypeList.admin, userType) && (
            <Grid container>
              <VcEGrid item xs={12} sm={2} className="input-text">
                <FormTitle>
                  {[...userTypeList.type2, ...userTypeList.type1].indexOf(
                    userType
                  ) !== -1
                    ? '*'
                    : ''}
                  快遞倉站：
                </FormTitle>
              </VcEGrid>
              <VcGrid item xs={12} sm={3}>
                <WarehouseModal
                  value={master.warehouse}
                  updateData={updateData}
                  setStatus={setWarehouseName}
                />
              </VcGrid>

              <VcGrid item xs={12} sm={3}>
                {warehouseName && (
                  <Alert
                    severity="info"
                    style={{
                      width: '100%',
                      color: 'red',
                      margin: '0 0.5rem',
                      fontSize: '1em',
                    }}
                    icon={false}
                  >
                    {warehouseName}
                  </Alert>
                )}
              </VcGrid>
            </Grid>
          )}

          <Grid container>
            <VcEGrid item xs={12} sm={2} className="input-text">
              <FormTitle>*拆櫃日期：</FormTitle>
            </VcEGrid>
            <VcGrid item xs={12} sm={5} style={{ maxWidth: 900 }}>
              <DateOneSePickersTyping
                required
                updateData={updateData}
                style={{ maxWidth: 200 }}
                inputDataName="declDate"
                data={master}
                seInterval={31}
              />
            </VcGrid>
          </Grid>

          <Grid container>
            <VcEGrid item xs={12} sm={2} className="input-text">
              <FormTitle>*船隻掛號：</FormTitle>
            </VcEGrid>
            <Grid item xs={12} sm={3}>
              <Input
                required
                maxLength={35}
                value={master.vesselRegNo}
                name="vesselRegNo"
                onChange={(e) => {
                  inputChange(updateData)(e);
                }}
                onBlur={(e) => {
                  getContainerNo(e);
                }}
              />
            </Grid>
          </Grid>

          <Grid container>
            <VcEGrid item xs={12} sm={2} className="input-text">
              <FormTitle>*貨櫃號碼：</FormTitle>
            </VcEGrid>
            <Grid item xs={12} sm={3}>
              <Autocomplete
                inputValue={master.containerNo}
                onInputChange={(event, newInputValue) => {
                  setMaster((prev) => ({
                    ...prev,
                    containerNo: newInputValue,
                  }));
                }}
                options={containerNoList}
                renderInput={(params) => <TextField {...params} label="" />}
              />
            </Grid>
          </Grid>

          <Grid container>
            <VcEGrid item xs={12} sm={2} className="input-text">
              封條號碼：
            </VcEGrid>
            <Grid item xs={12} sm={4}>
              <Input
                maxLength={140}
                value={master.sealNoInfo}
                name="sealNoInfo"
                onChange={(e) => {
                  inputChange(updateData)(e);
                }}
              />
            </Grid>
          </Grid>

          <Grid container>
            <VcEGrid item xs={12} sm={2} className="input-text">
              <FormTitle>*動態日期及時間：</FormTitle>
            </VcEGrid>
            <VcGrid item xs={12} sm={6} style={{ maxWidth: 1200 }}>
              <DateTimeOneSePickersTyping
                required
                updateData={updateData}
                names={[
                  ['statusDate', 'statusTime'],
                  ['statusDate', 'statusTime'],
                ]}
                data={master}
              />
            </VcGrid>
          </Grid>

          <Grid container>
            <VcEGrid item xs={12} sm={2} className="input-text">
              <FormTitle>*貨櫃動態：</FormTitle>
            </VcEGrid>
            <Grid item xs={12} sm={3}>
              <Select
                required
                // placeholder="請先填入分號"
                value={master.statusCode}
                onChange={selectChange(updateData)}
                name="statusCode"
                options={statusCodeOptions}
                // disabled={options.length === 0}
              />
            </Grid>
          </Grid>

          <Grid container>
            <VcEGrid item xs={12} sm={2} className="input-text">
              櫃動庫登錄帳號：
            </VcEGrid>
            <Grid item xs={12} sm={3}>
              <Input
                required
                maxLength={35}
                value={master.imctUserId}
                name="imctUserId"
                onChange={(e) => {
                  inputChange(updateData)(e);
                }}
              />
            </Grid>
          </Grid>
        </div>
        <Grid container className="button-area">
          <VcEGrid item xs={12} sm={2}>
            <Button
              disabled={formError}
              type="submit"
              variant="contained"
              color="primary"
              startIcon={<SaveIcon />}
              onClick={() => setSubmitKey('confirm')}
            >
              送出動態
            </Button>
          </VcEGrid>
          <VcEGrid item xs={12} sm="auto">
            <Button
              disabled={formError}
              type="submit"
              variant="contained"
              color="primary"
              startIcon={<RefreshIcon />}
              onClick={() => handleReset()}
            >
              重置
            </Button>
          </VcEGrid>
          <VcEGrid item xs={12} sm="auto">
            <Button
              disabled={formError}
              type="submit"
              variant="contained"
              color="primary"
              startIcon={<DeleteIcon />}
              onClick={() => setSubmitKey('deleteItem')}
            >
              刪除動態
            </Button>
          </VcEGrid>
          <Grid item xs={12} sm="auto">
            <Button
              disabled={formError}
              type="submit"
              variant="contained"
              color="default"
              startIcon={<PrintIcon />}
              onClick={() => setSubmitKey('getPic')}
            >
              顯示櫃號拆空圖片
            </Button>
          </Grid>
        </Grid>
      </form>

      {images &&
        images.length > 0 &&
        images.map((image, index) => (
          <div>
            <img
              key={image.imageName}
              id={image.imageName}
              // src={`data:${image.mimeType};base64,${image.srcImage}`}
              src={image.srcImage}
              alt=""
            />
          </div>
        ))}
    </div>
  );
};

export default CtgdsStatusMtn;
